import { Reveal } from "../components/Reveal";
import { scrollToId } from "./Nav";

export default function FinalCta() {
  return (
    <section
      id="cta"
      data-testid="final-cta-section"
      className="bg-teal py-24 md:py-32"
    >
      <div className="mx-auto max-w-3xl px-6 text-center">
        <Reveal>
          <h2 className="font-display text-3xl font-medium leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
            See it for yourself
          </h2>
        </Reveal>
        <Reveal delay={140}>
          <p className="mt-6 text-base leading-relaxed text-white/75 md:text-lg">
            A short, no-pressure call to walk through how Leadtochair would work
            with your practice&apos;s existing setup.
          </p>
        </Reveal>
        <Reveal delay={260}>
          <button
            data-testid="final-cta-book-demo-btn"
            onClick={() => scrollToId("contact")}
            className="mt-10 rounded-full bg-white px-9 py-4 text-sm font-semibold tracking-wide text-teal transition-colors hover:bg-teal-soft"
          >
            Book a Demo
          </button>
        </Reveal>
      </div>
    </section>
  );
}
